import { defineStore } from "pinia";

interface State {
  answers: any;
  previous_answers: any;
  answer_date: string;
  subject_number: string;
  answer_change_reason: string;
}

export const useAnswerStore = defineStore('answer', {
  state: (): State => ({
    answers: {},
    previous_answers: {},
    answer_date: '',
    subject_number: '',
    answer_change_reason: '',
  }),

  getters: {
  },

  actions: {
  },
  persist: true,
});
